/**
 * @file コンポーネント：フル動画ページフル動画プレイヤーボタンリスト DOM管理
 */

// ライブラリ読み込み
import React from "react";

// 関数読み込み
import { fnConvertSecondToTimeString } from "~/src/functions/common";

// スタイル読み込み
import {
    StyledButtonlist,
    StyledButtonlistButton,
    StyledButtonlistButtonText,
    StyledButtonlistItem,
    StyledButtonlistJump,
    StyledButtonlistJumpInput,
    StyledButtonlistJumpPulldown,
    StyledButtonlistJumpPulldownSelect,
    StyledButtonlistJumpPulldownSelectOption,
    StyledButtonlistMenu,
    StyledButtonlistMenuLabel,
    StyledButtonlistMenuLabelCheckbox,
    StyledButtonlistMenuLabelIcon,
    StyledButtonlistMenuLabelText,
    StyledButtonlistMenuList,
    StyledButtonlistMenuListDetail,
    StyledButtonlistMenuListTerm,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <>
            {/* ジャンプボタン（左側内左側に位置） */}
            <StyledButtonlist ref={props.refFullvideoPlayerJumpButton}>
                {/* 1分巻き戻しボタン */}
                <StyledButtonlistItem>
                    <StyledButtonlistButton
                        disabled={props.timeProgressSecond - 60 < 0}
                        onClick={() =>
                            props.fnJump(
                                fnConvertSecondToTimeString(
                                    props.timeProgressSecond - 60
                                )
                            )
                        }
                        title={localized["Label.PlayerButtonJumpBackOneMinute"]}
                    >
                        <i className="fas fa-undo"></i>
                        <StyledButtonlistButtonText>
                            1
                        </StyledButtonlistButtonText>
                    </StyledButtonlistButton>
                </StyledButtonlistItem>
                {/* 指定の秒・分巻き戻し機能 */}
                <StyledButtonlistItem>
                    <StyledButtonlistJump>
                        {/* 巻き戻しボタン */}
                        <StyledButtonlistButton
                            disabled={
                                props.timeProgressSecond -
                                    props.timeInputSecond <
                                0
                            }
                            onClick={() =>
                                props.fnJump(
                                    fnConvertSecondToTimeString(
                                        props.timeProgressSecond -
                                            props.timeInputSecond
                                    )
                                )
                            }
                            title={
                                localized[
                                    "Label.PlayerButtonJumpBackSpecifiedTime"
                                ]
                            }
                        >
                            <i className="fas fa-undo"></i>
                            <StyledButtonlistButtonText>
                                n
                            </StyledButtonlistButtonText>
                        </StyledButtonlistButton>
                        {/* 時間指定テキストフィールド */}
                        <StyledButtonlistJumpInput
                            defaultValue={1}
                            max={props.maxInputNumber}
                            min={1}
                            onInput={(e) => props.fnOnInputNumber(e)}
                            ref={props.refInputNumber}
                            step={1}
                            type="number"
                        />
                        {/* 時間単位指定プルダウン */}
                        <StyledButtonlistJumpPulldown>
                            <StyledButtonlistJumpPulldownSelect
                                defaultValue="sec"
                                onChange={(e) => props.fnOnChangeSelect(e)}
                            >
                                <StyledButtonlistJumpPulldownSelectOption value="sec">
                                    {localized["Label.Second"]}
                                </StyledButtonlistJumpPulldownSelectOption>
                                <StyledButtonlistJumpPulldownSelectOption value="min">
                                    {localized["Label.Minute"]}
                                </StyledButtonlistJumpPulldownSelectOption>
                            </StyledButtonlistJumpPulldownSelect>
                        </StyledButtonlistJumpPulldown>
                        {/* 早送りボタン */}
                        <StyledButtonlistButton
                            disabled={
                                props.timeProgressSecond +
                                    props.timeInputSecond >
                                props.timeTotalSecond
                            }
                            onClick={() =>
                                props.fnJump(
                                    fnConvertSecondToTimeString(
                                        props.timeProgressSecond +
                                            props.timeInputSecond
                                    )
                                )
                            }
                            title={
                                localized[
                                    "Label.PlayerButtonJumpForwardSpecifiedTime"
                                ]
                            }
                        >
                            <i className="fas fa-redo"></i>
                            <StyledButtonlistButtonText>
                                n
                            </StyledButtonlistButtonText>
                        </StyledButtonlistButton>
                    </StyledButtonlistJump>
                </StyledButtonlistItem>
                {/* 1分早送りボタン */}
                <StyledButtonlistItem>
                    <StyledButtonlistButton
                        disabled={
                            props.timeProgressSecond + 60 >
                            props.timeTotalSecond
                        }
                        onClick={() =>
                            props.fnJump(
                                fnConvertSecondToTimeString(
                                    props.timeProgressSecond + 60
                                )
                            )
                        }
                        title={
                            localized["Label.PlayerButtonJumpForwardOneMinute"]
                        }
                    >
                        <i className="fas fa-redo"></i>
                        <StyledButtonlistButtonText>
                            1
                        </StyledButtonlistButtonText>
                    </StyledButtonlistButton>
                </StyledButtonlistItem>
            </StyledButtonlist>
            {/* 設定ボタン（右側内左側に位置） */}
            <StyledButtonlist ref={props.refFullvideoPlayerButtonlistSetting}>
                {/* 字幕表示ボタン */}
                <StyledButtonlistItem>
                    <StyledButtonlistButton
                        className={props.isShowSubtitle === false && "is-off"}
                        onClick={() =>
                            props.setIsShowSubtitle(!props.isShowSubtitle)
                        }
                        title={localized["Label.PlayerButtonSubtitle"]}
                    >
                        <i className="fas fa-closed-captioning"></i>
                    </StyledButtonlistButton>
                </StyledButtonlistItem>
                {/* アイコン表示ボタン */}
                <StyledButtonlistItem
                    onMouseEnter={() => props.setIsShowSettingIconlist(true)}
                    onMouseLeave={() => props.setIsShowSettingIconlist(false)}
                >
                    <StyledButtonlistButton
                        title={localized["Label.PlayerButtonIcon"]}
                    >
                        <i className="fas fa-comment"></i>
                    </StyledButtonlistButton>
                    {/* アイコン表示メニュー */}
                    <StyledButtonlistMenu
                        className={
                            props.isShowSettingIconlist === true && "is-show"
                        }
                    >
                        <StyledButtonlistMenuList>
                            <StyledButtonlistMenuListTerm>
                                {localized["Label.SelectIcon"]}
                            </StyledButtonlistMenuListTerm>
                            <StyledButtonlistMenuListDetail>
                                <StyledButtonlistMenuLabel>
                                    <StyledButtonlistMenuLabelCheckbox
                                        defaultChecked={props.isShowIconComment}
                                        onChange={() =>
                                            props.setIsShowIconComment(
                                                !props.isShowIconComment
                                            )
                                        }
                                        type="checkbox"
                                    />
                                    <StyledButtonlistMenuLabelIcon>
                                        <i className="fas fa-comment"></i>
                                    </StyledButtonlistMenuLabelIcon>
                                    <StyledButtonlistMenuLabelText>
                                        {localized["Label.Comment"]}
                                    </StyledButtonlistMenuLabelText>
                                </StyledButtonlistMenuLabel>
                            </StyledButtonlistMenuListDetail>
                            <StyledButtonlistMenuListDetail>
                                <StyledButtonlistMenuLabel>
                                    <StyledButtonlistMenuLabelCheckbox
                                        defaultChecked={props.isShowIconTopic}
                                        onChange={() =>
                                            props.setIsShowIconTopic(
                                                !props.isShowIconTopic
                                            )
                                        }
                                        type="checkbox"
                                    />
                                    <StyledButtonlistMenuLabelIcon>
                                        <i className="fas fa-comments"></i>
                                    </StyledButtonlistMenuLabelIcon>
                                    <StyledButtonlistMenuLabelText>
                                        {localized["Label.Topic"]}
                                    </StyledButtonlistMenuLabelText>
                                </StyledButtonlistMenuLabel>
                            </StyledButtonlistMenuListDetail>
                            <StyledButtonlistMenuListDetail>
                                <StyledButtonlistMenuLabel>
                                    <StyledButtonlistMenuLabelCheckbox
                                        defaultChecked={props.isShowIconEvent}
                                        onChange={() =>
                                            props.setIsShowIconEvent(
                                                !props.isShowIconEvent
                                            )
                                        }
                                        type="checkbox"
                                    />
                                    <StyledButtonlistMenuLabelIcon>
                                        <i className="fas fa-flag"></i>
                                    </StyledButtonlistMenuLabelIcon>
                                    <StyledButtonlistMenuLabelText>
                                        {localized["Label.Event"]}
                                    </StyledButtonlistMenuLabelText>
                                </StyledButtonlistMenuLabel>
                            </StyledButtonlistMenuListDetail>
                        </StyledButtonlistMenuList>
                    </StyledButtonlistMenu>
                </StyledButtonlistItem>
            </StyledButtonlist>
        </>
    );
};
